import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { List as MovableList } from 'react-movable';
import { ListContentWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { CompetitionCombinedType } from 'src/AppState/CmsState/TopEventsState/TopEventsState';
import { TopEventsSportState } from 'src/main/cms/TopEvents/topEventsState/TopEventsSportState';
import { TopEventsEventsListState } from './TopEventsCompetitionSectionWrapper.state';
import { TopEventsEventCompetitionSection, TopEventsEventSection } from './TopEventsSections';

interface PropsType {
    competitionData: CompetitionCombinedType;
    topEventsEventSportState: TopEventsSportState;
    isDragged: boolean;
    sportId: string;
}
export const TopEventsEventCompetitionSectionWrapper = observer(
    'TopEventsEventCompetitionSectionWrapper',
    ({ competitionData, topEventsEventSportState, sportId, isDragged }: PropsType) => {
        const {
            cmsState: { topEventsState },
            sdkStaff,
            trpcClient,
        } = useAppStateContext();
        const topEventsEventCompetitionState = topEventsEventSportState.getTopEventsEventCompStateByCompId(
            competitionData.competition_id
        );
        const [state] = useState(
            () => new TopEventsEventsListState(sdkStaff, trpcClient, topEventsState, sportId, competitionData)
        );

        if (state.isAnyEvents === false) {
            return null;
        }

        return (
            <>
                <TopEventsEventCompetitionSection
                    label={state.competitionName}
                    isOpen={topEventsEventCompetitionState.isOpenSection}
                    isDragged={isDragged}
                    topEventsEventCompetitionState={topEventsEventCompetitionState}
                    dataTest={`topEvents-event-competition-${state.competitionName.toLowerCase()}`}
                />
                {topEventsEventCompetitionState.isOpenSection === false ? null : (
                    <MovableList
                        values={competitionData.events_list}
                        onChange={state.handleEventsOrder}
                        renderList={({ children, props, isDragged }): React.ReactNode => (
                            <ListContentWrapper
                                {...props}
                                isDragged={isDragged}
                            >
                                {children}
                            </ListContentWrapper>
                        )}
                        renderItem={({ value, props, isDragged }): JSX.Element | null => {
                            return (
                                <div
                                    {...props}
                                    style={{ ...props.style, zIndex: 'initial' }}
                                >
                                    <TopEventsEventSection
                                        key={value.id}
                                        eventData={value}
                                        getCompetitionData={topEventsEventSportState.getCompetitionData}
                                        handleDeleteCompetition={topEventsEventCompetitionState.handleDeleteCompetition}
                                        topEventsEventsSectionState={topEventsState}
                                        isDragged={isDragged}
                                        dataTest={`topEvents-event-${value.event_id.toString()}`}
                                    />
                                </div>
                            );
                        }}
                    />
                )}
            </>
        );
    }
);
